<template>
  <div>
    <b-table
      ref="table"
      class="bg-white"
      small
      responsive
      show-empty
      :fields="fields"
      :items="items"
    >
      <template #empty>
        <p align="center">{{ trans('no_booking_found') }}</p>
      </template>
      <template #cell(events)="data">
        <b-button v-if="data.item.operation == 'delete'" variant="outline-success" size="sm" @click="onClickRestore(data.item, data.item.no-1)">
          {{ trans('restore') }}
        </b-button>
        <small v-for="(event, index) in data.value || []" :key="event.id" v-if="show_more_events[data.item.no] || index < 2" class="d-block">
          {{ `${event.location_name} @ ${moment(event.start).format('LLL')} - ${moment(event.end).format('LT')}` }}
        </small>
        <small v-if="!!data.item.events && data.item.events.length > 2" class="d-block">
          <b-button variant="link" size="sm" class="p-0 text-muted" @click="onClickToggleMoreShowEvents(data.item)">
            <span v-if="!show_more_events[data.item.no]">
              {{ getMoreCountText(data.item) }}
              <i class="fa fa-fw fa-chevron-right"></i>
            </span>
            <span v-if="show_more_events[data.item.no]">
              <i class="fa fa-fw fa-chevron-left"></i>
              {{ trans('less').toLowerCase() }}
            </span>
          </b-button>
        </small>
      </template>
    </b-table>
    <restore-booking-modal
      :id="restoreBookingModalId"
      :organization="organization"
      :booking="booking"
      :log="log"
      :index="index"
      @restored="$emit('restored', $event)"
    ></restore-booking-modal>
  </div>
</template>

<script>
  import RestoreBookingModal from './RestoreBookingModal'

  export default {
    props: {
      organization: Object,
      booking: Object,
    },
    components: {
      RestoreBookingModal,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        fields: [
          {
            key: 'no',
            label: 'No',
          },
          {
            key: 'operation',
            label: trans('operation'),
            formatter(value, key, item) {
              return trans(value)
            },
          },
          {
            key: 'created_at',
            label: trans('created_on'),
            formatter(value, key, item) {
              return moment(value).format('LLL')
            },
          },
          {key: 'admin_name', label: trans('admin_name')},
          {
            key: 'events',
            label: trans('events'),
          },
        ],
        show_more_events: {},
        log: null,
        index: null,
      }
    },
    computed: {
      restoreBookingModalId() {
        return `restore-booking-modal-${this.booking.id}`
      },
      items() {
        if (!this.booking || !this.booking.log) return []
        return _.reduce(this.booking.log, (logs, l, no) => {
          logs.unshift(_.assign({no: no+1}, l))
          return logs
        }, [])
      },
    },
    methods: {
      onClickRestore(log, index) {
        this.log = log
        this.index = index
        this.$bvModal.show(this.restoreBookingModalId)
      },
      onClickToggleMoreShowEvents(log) {
        this.$set(this.show_more_events, log.no, !this.show_more_events[log.no])
      },
      getMoreCountText(log) {
        let moreCount = !!log.events && log.events.length > 2 ? log.events.length - 2 : 0
        if (!moreCount) return null
        return `${moreCount} ${trans('other' + (moreCount > 1 || moreCount == 0 && lang == 'en' ? 's' : '')).toLowerCase()} (${log.events.length} ${trans('total').toLowerCase()})`
      },
    },
    mounted() {
      window.bookingLog = this
    },
  }
</script>